module.exports = __webpack_public_path__ + "img/Mage-troll-f-70.d5ac4d2f.gif";